import { DefaultButton, FontWeights, IButtonStyles, IconButton, IIconProps, mergeStyleSets, Modal, PrimaryButton, Stack, TextField, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IHtmlText } from '../../../../Models/HtmlTexts/IHtmlText';
import { TextEditor } from './TextEditor';

interface ITextEditProps {
    htmlText: IHtmlText;
    isOpened: boolean;
    onDismiss: () => void;
    save: (text: string,title:string) => void;
}


export const TextEdit: React.FunctionComponent<ITextEditProps> = (props) => {
    const [title, setTitle] = React.useState<string>("");
    const [text, setText] = React.useState<string>("");

     
    const titleId = useId('title');
    const theme = useTheme();


    React.useEffect(() => {
        if (props.htmlText) {
            setTitle(props.htmlText.title);
            setText(props.htmlText.text);

        }
        else {
            setTitle("");
            setText("");
        }

    }, [props.htmlText])


    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };

    const save = (text: string) => {
        props.save(text, title);
    }

    return (<Modal
        titleAriaId={titleId}
        isOpen={props.isOpened}
        onDismiss={props.onDismiss}
        isBlocking={false}
        containerClassName={contentStyles.container}>
        <div className={contentStyles.header}>
            <span id={titleId}>Editace textů</span>
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Zavři"
                onClick={props.onDismiss} />
        </div>
        <div className={contentStyles.body}>
            <TextEditor text={text} title={title} close={props.onDismiss} setText={save} setTitle={setTitle} />
        </div>
    </Modal>)
}
